import { Component, OnInit, ChangeDetectionStrategy, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { IPrepLocationHoursOverride } from 'src/app/common/models/prep-location-hours-override';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-override-delete-confirm',
  templateUrl: './override-delete-confirm.component.html',
  styleUrls: ['./override-delete-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CdkScrollable, MatDialogContent, MatButton, DatePipe],
})
export class OverrideDeleteConfirmComponent {
  constructor(
    public dialogRef: MatDialogRef<OverrideDeleteConfirmComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public override: IPrepLocationHoursOverride,
  ) {}

  public confirm(decision: boolean): void {
    this.dialogRef.close(decision);
  }
}
